var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21671 4.85268H5.131V10.3384H4.21671V4.85268Z",
    fill: "#FF4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95957 4.85268H7.87386V10.3384H6.95957V4.85268Z",
    fill: "#FF4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.55957 2.10982V3.02411H1.47386V12.167C1.47386 12.4094 1.57018 12.642 1.74164 12.8135C1.91311 12.9849 2.14566 13.0813 2.38814 13.0813H9.70243C9.94491 13.0813 10.1775 12.9849 10.3489 12.8135C10.5204 12.642 10.6167 12.4094 10.6167 12.167V3.02411H11.531V2.10982H0.55957ZM2.38814 12.167V3.02411H9.70243V12.167H2.38814Z",
    fill: "#FF4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21671 0.28125H7.87386V1.19554H4.21671V0.28125Z",
    fill: "#FF4343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDelete);
export default __webpack_public_path__ + "static/media/new_delete.373d27a3e350f86075b8fa7e9ef7d49e.svg";
export { ForwardRef as ReactComponent };